export default "__VITE_ASSET__D0LsoD3A__"